import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { PostTypesDataService, PostTypesColumnsService } from '../../../services';
import { PostType, PostTypesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-post-type-details',
  templateUrl: './post-type-details.component.html',
  styleUrls: ['./post-type-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class PostTypeDetailsComponent implements OnInit, OnDestroy {

  public postType: PostType = {};
  public postTypes: PostType[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private postTypesDataService: PostTypesDataService,
    private postTypesColumnsService: PostTypesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Post Type - Details');
        this.getPostType(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.postType !== 'undefined') {
      this.postType = this.dynamicDialogConfig.data.postType;
    }
    this.columns = this.postTypesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getPostType(id: number): void {
    this.isLoading = true;
    this.postTypesDataService.getPostType(id).subscribe((response: PostType|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.postType = response;
      }
    });
  }

  list() {
    this.router.navigate(['/post-types']);
  }

  add() {
    this.router.navigate(['/post-types/add']);
  }

  edit() {
    this.router.navigate(['/post-types/edit/' + this.postType.id]);
  }

}
@Component({
  selector: 'app-post-type-details',
  templateUrl: './post-type-details.component.html',
  styleUrls: ['./post-type-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogPostTypeDetailsComponent extends PostTypeDetailsComponent {
}

